/**
 * Article ESM entry point.
 *
 * Loaded only on the article template via a
 * `{% if template.name == 'article' %}` gate in content-for-footer.liquid.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntryArticle]
 */

import { log } from './log.js';
import './article.js';

log('[App] entry-article loaded');
